// Shared activity-type metadata for Pipeline Sequences (step editor + list preview).
// `icon` must be a valid key in shared/components/FluentIcon/dashboard-icons.json
// as `${icon}-outline` — see activityTypes.spec.js for the regression guard.
export const ACTIVITY_TYPES = [
  'call',
  'email',
  'meeting',
  'task',
  'note',
  'demo',
  'follow_up',
  'webhook',
  'whatsapp_message',
  'whatsapp_media',
  'delay',
];

export const ACTIVITY_META = {
  call: { icon: 'call', tone: 'bg-iris-3 text-iris-11', category: 'activity' },
  email: {
    icon: 'mail',
    tone: 'bg-blue-3 text-blue-11',
    category: 'activity',
  },
  meeting: {
    icon: 'people-team',
    tone: 'bg-violet-3 text-violet-11',
    category: 'activity',
  },
  task: {
    icon: 'document',
    tone: 'bg-amber-3 text-amber-11',
    category: 'activity',
  },
  note: {
    icon: 'book',
    tone: 'bg-yellow-3 text-yellow-11',
    category: 'activity',
  },
  demo: {
    icon: 'video',
    tone: 'bg-pink-3 text-pink-11',
    category: 'activity',
  },
  follow_up: {
    icon: 'arrow-clockwise',
    tone: 'bg-grass-3 text-grass-11',
    category: 'activity',
  },
  webhook: {
    icon: 'arrow-swap',
    tone: 'bg-violet-3 text-violet-11',
    category: 'integration',
  },
  whatsapp_message: {
    icon: 'chat',
    tone: 'bg-grass-3 text-grass-11',
    category: 'communication',
  },
  whatsapp_media: {
    icon: 'image',
    tone: 'bg-grass-3 text-grass-11',
    category: 'communication',
  },
  delay: {
    icon: 'calendar-clock',
    tone: 'bg-sand-3 text-sand-11',
    category: 'time',
  },
};

// Generic fallback for a step whose activity_type isn't in ACTIVITY_META
// (e.g. legacy/unknown data) — must also be a valid dashboard-icons.json key.
export const DEFAULT_ACTIVITY_ICON = 'status';

export const activityIconFor = type =>
  ACTIVITY_META[type]?.icon || DEFAULT_ACTIVITY_ICON;
